/* istanbul ignore file */

import React from 'react'
import {Helmet} from 'react-helmet'
import useMultiSite from '../../hooks/use-multi-site'
import {getStaticHost} from '../../utils/site-utils'
import {isServer} from '../../utils/utils'

const CMSGlobalStyles = () => {
    const {site, locale} = useMultiSite()
    const staticHost = getStaticHost()

    return (
        <>
            <Helmet>
                <link
                    rel="stylesheet"
                    href={`${staticHost}/on/demandware.static/Sites-${
                        site.alias || site.id
                    }-Site/-/${locale.alias || locale.id}/css/cms-style${
                        process.env.NODE_ENV === 'production' ? '.min' : ''
                    }.css`}
                    media={
                        // use print styles for server side rendering so the css is not blocking and
                        // switch to all media types on client side after hydration
                        isServer ? 'print' : 'all'
                    }
                />
            </Helmet>
        </>
    )
}

export default CMSGlobalStyles
